import { Component, Input } from '@angular/core';
import { Observable } from 'rxjs';

interface ConservationShapeEntity {
  entityId: number;
  entityType: string;
}

interface ConservationMapShape {
  shapeId: number;
  shapeWkt: string;
  shapeData: {
    entity: ConservationShapeEntity;
  };
}

interface MiniConservationDocumentView {
  documentLongId: string;
  documentTitle: string;
  entityId: number;
}

interface MiniConservationFolderView {
  folderLongId: string;
  folderTitle: string;
  entityId: number;
}

export interface ConservationArchiveFolderView {
  entityId: number;
  folderLongId: string;
  archiveCode: string;
  folderNumber: string;
  folderTitle: string;
  siteId: number | null;
  siteSubId: number | null;
  boxId: number | null;
  siteEntityId: number;
  siteName: string;
  siteType: string;
  totalDocuments: number | null;
  folderHasScannedFiles: boolean;
  folderDownloadUrl: string;
  documents: MiniConservationDocumentView[];
  additionalFolders: MiniConservationFolderView[];
  archiveMapInformation: ConservationMapShape[];
}

@Component({
  selector: 'conservation-archive-folder-details',
  templateUrl: './conservation-archive-folder-details.component.html',
  styleUrls: ['./conservation-archive-folder-details.component.scss'],
})
export class ConservationArchiveFolderDetailsComponent {
  @Input() details!: ConservationArchiveFolderView;
  @Input() currentLanguage!: Observable<string>;
  @Input() onViewSite!: (entityId: number) => void;
  @Input() onViewFolder!: (entityId: number) => void;
  @Input() onViewDocument!: (entityId: number) => void;
  @Input() onDownload!: () => void;

  get hasScannedFilesTextKey(): string {
    return this.details?.folderHasScannedFiles ? 'iaa.conservationArchive.folder.scanned' : 'iaa.conservationArchive.folder.notScanned';
  }

  get totalDocumentsDisplay(): number {
    if (this.details?.totalDocuments !== null && this.details?.totalDocuments !== undefined) {
      return this.details.totalDocuments;
    }

    return this.details?.documents?.length || 0;
  }

  get hasSiteData(): boolean {
    return (this.details?.siteEntityId || 0) > 0
      || (this.details?.siteId || 0) > 0
      || !!(this.details?.siteName && this.details.siteName.trim().length > 0)
      || !!(this.details?.siteType && this.details.siteType.trim().length > 0);
  }

  get canNavigateToSite(): boolean {
    return (this.details?.siteEntityId || 0) > 0 && this.details?.siteEntityId !== 0;
  }
}
